import { useLocation } from 'react-router-dom';
import { asset } from '../assets';
import { editingQuotePath } from '../quoteEdit';
import { createQuoteItem, validateQuoteConfiguration } from '../quoteItem';
import { useLanguage } from './LanguageProvider';
import { useQuoteCart } from './QuoteCartProvider';

export function QuoteActions({ configureOnly = false, productType }) {
  const location = useLocation();
  const { addItem, cancelEditing, checkoutItem, editingItem, submitting, uploadProgress } = useQuoteCart();
  const { t } = useLanguage();
  const isEditing = editingQuotePath(editingItem) === location.pathname;

  const currentQuote = () => {
    const configuration = document.getElementById('configuration');
    const validation = validateQuoteConfiguration(configuration);

    if (!validation.isValid) {
      validation.firstInvalid?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      validation.firstInvalid?.querySelector('input, select, textarea')?.focus();
      return null;
    }

    return createQuoteItem(productType, location.pathname);
  };

  const addCurrentQuote = () => {
    const quote = currentQuote();
    if (quote) addItem(quote);
  };

  const requestQuote = () => {
    const configuration = document.getElementById('configuration');

    if (configureOnly && configuration) {
      configuration.scrollIntoView({ behavior: 'smooth', block: 'start' });
      return;
    }

    const quote = currentQuote();
    if (quote) checkoutItem(quote);
  };

  return (
    <div className={`quote-actions${configureOnly ? ' quote-actions-configure' : ''}${isEditing ? ' quote-actions-editing' : ''}`}>
      {!configureOnly && (
        <>
          <button className="btn3" onClick={addCurrentQuote} type="button">
            <img
              aria-hidden="true"
              className="cart-action-icon"
              src={asset(isEditing ? 'assets/edit.svg' : 'assets/cart.svg')}
              alt=""
            />
            {isEditing ? t('Update Cart', 'تحديث السلة') : t('Add to Cart', 'أضف إلى السلة')}
          </button>
          {isEditing && (
            <button className="quote-cancel-edit" onClick={cancelEditing} type="button">
              {t('Cancel editing', 'إلغاء التعديل')}
            </button>
          )}
        </>
      )}
      <button className="btn2" disabled={submitting} onClick={requestQuote} type="button">
        {uploadProgress
          ? t('Uploading files...', 'جاري رفع الملفات...')
          : submitting
            ? t('Submitting...', 'جاري الإرسال...')
            : t('Request Quote', 'طلب عرض سعر')}
        <img aria-hidden="true" className="btn-arrow" src={asset('assets/arrow.svg')} alt="" />
      </button>
    </div>
  );
}
